"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _baseService = _interopRequireDefault(require("@/config/base-service"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var MonitorService = /*#__PURE__*/function (_BaseService) {
  function MonitorService() {
    _classCallCheck(this, MonitorService);
    return _callSuper(this, MonitorService, ["monitor"]);
  }
  _inherits(MonitorService, _BaseService);
  return _createClass(MonitorService, [{
    key: "fetchListMonitor",
    value: function fetchListMonitor(params) {
      return this.get("list", {
        params: params
      });
    }
  }, {
    key: "fetchCountRequestPerType",
    value: function fetchCountRequestPerType(_ref) {
      var typeRequest = _ref.typeRequest,
        service = _ref.service;
      return this.get("services-actives/".concat(typeRequest, "/").concat(service));
    }
  }, {
    key: "fetchLatestCallServiceActiveChartReception",
    value: function fetchLatestCallServiceActiveChartReception(_ref2) {
      var typeRequest = _ref2.typeRequest,
        service = _ref2.service,
        period = _ref2.period;
      var params = _objectSpread({}, period);
      return this.get("services-actives/".concat(typeRequest, "/").concat(service, "/chart"), {
        params: params
      });
    }
  }, {
    key: "fetchServicesLatestRequestPerType",
    value: function fetchServicesLatestRequestPerType(_ref3) {
      var typeRequest = _ref3.typeRequest,
        service = _ref3.service,
        period = _ref3.period;
      var params = _objectSpread({}, period);
      return this.get("services-latest/".concat(typeRequest, "/").concat(service), {
        params: params
      });
    }
  }, {
    key: "fetchServicesSuccessAndErrors",
    value: function fetchServicesSuccessAndErrors(_ref4) {
      var typeRequest = _ref4.typeRequest,
        service = _ref4.service,
        period = _ref4.period;
      var params = _objectSpread({}, period);
      return this.get("services-status/".concat(typeRequest, "/").concat(service), {
        params: params
      });
    }
  }, {
    key: "fetchServicesStatusRequestChart",
    value: function fetchServicesStatusRequestChart(_ref5) {
      var typeRequest = _ref5.typeRequest,
        service = _ref5.service,
        period = _ref5.period;
      var params = _objectSpread({}, period);
      return this.get("services-status-chart/".concat(typeRequest, "/").concat(service), {
        params: params
      });
    }
  }, {
    key: "fetchServiceRequestErrorsList",
    value: function fetchServiceRequestErrorsList(_ref6) {
      var typeRequest = _ref6.typeRequest,
        service = _ref6.service,
        period = _ref6.period;
      var params = _objectSpread({}, period);
      return this.get("services-errors/".concat(typeRequest, "/").concat(service), {
        params: params
      });
    }

    // TODO: Revisar rotas
  }, {
    key: "fetchReception",
    value: function fetchReception(service) {
      return this.get("monitor-service/".concat(service));
    }
  }, {
    key: "fetchLatestServiceCallReception",
    value: function fetchLatestServiceCallReception(period) {
      var params = _objectSpread({}, period);
      return this.get("services-actives/list", {
        params: params
      });
    }
  }, {
    key: "fetchLatestServiceCallChartReception",
    value: function fetchLatestServiceCallChartReception(period) {
      var params = _objectSpread({}, period);
      return this.get("services-actives/chart", {
        params: params
      });
    }
  }, {
    key: "fetchTotalRequestByService",
    value: function fetchTotalRequestByService(id, params) {
      return this.get("get-total-requests/".concat(id), {
        params: params
      });
    }
  }, {
    key: "fetchChartRequestCreatedHive",
    value: function fetchChartRequestCreatedHive(id, params) {
      return this.get("chart/requests/create-hive/".concat(id), {
        params: params
      });
    }
  }, {
    key: "fetchChartRequestCreatedProvider",
    value: function fetchChartRequestCreatedProvider(id, params) {
      return this.get("chart/requests/create-provider/".concat(id), {
        params: params
      });
    }
  }, {
    key: "fetchChartRequestReceivedHive",
    value: function fetchChartRequestReceivedHive(id, params) {
      return this.get("chart/requests/received-hide/".concat(id), {
        params: params
      });
    }
  }, {
    key: "fetchChartRequestSendClient",
    value: function fetchChartRequestSendClient(id, params) {
      return this.get("chart/requests/send-client/".concat(id), {
        params: params
      });
    }
  }, {
    key: "fetchLatestRequestStepByService",
    value: function fetchLatestRequestStepByService(id, params) {
      return this.get("get-latest-request-by-step/".concat(id), {
        params: params
      });
    }
  }, {
    key: "fetchRequestsTimeIntervals",
    value: function fetchRequestsTimeIntervals(serviceId, startDate, endDate) {
      return this.get("get-time-to-request/".concat(serviceId, "?startDate=").concat(startDate, "&endDate=").concat(endDate));
    }
  }, {
    key: "fetchChartRequestTime",
    value: function fetchChartRequestTime(id, params) {
      return this.get("chart/requests/timestamp/".concat(id), {
        params: params
      });
    }
  }]);
}(_baseService.default);
var _default = exports.default = new MonitorService();